import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faShieldHalved } from "@fortawesome/free-solid-svg-icons";

const Section1 = ({url}) => {

  return (
    <section
        className="home-section-1"
        >
        <div className="container">
            <div className="hero-inner-1">
                {/* Left Content */}
                <div className="hero-content" data-aos="fade-right">
                    <img src={`${url}images/intelihire/logo.png`} alt="InteliHire Logo" className="hero-logo" />

                    <h1 className="hero-title">
                    Hire the Right Talent <br />
                    <span className="gradient-text">10x Faster with InteliHire</span>
                    </h1>

                    <p className="hero-subtitle">
                        Cut hiring time by <b>60%</b> and eliminate <b>90%</b> of manual screening work with our AI recruiting software
                    </p>

                    <button
                    className="btn btn-gradient mt-4"
                    data-aos="zoom-in"
                    data-aos-delay="300"
                    >
                    See Intelihire in Action
                    </button>
                </div>
            </div>
            <div className="hero-inner-2 overflow-hidden">
                            {/* Right: Person Image + Floating Cards */}
                <div className="hero-visual" data-aos="fade-up" data-aos-delay="200">
                    <div className="hero-image-wrapper">
                    <img src={`${url}images/intelihire/back-right.png`} alt="Hero Visual" className="hero-person-img" />
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Section1;
